/* eslint-disable default-case */
import React, { lazy, Suspense } from 'react';

import { IoMdFingerPrint } from '@/components/Icons/CustomIcons';
import { formatMessage } from '@/i18n';

const FaKey = lazy(() => import('react-icons/fa').then(mod => ({ default: mod.FaKey })));
const FaSimCard = lazy(() => import('react-icons/fa').then(mod => ({ default: mod.FaSimCard })));
const FaBolt = lazy(() => import('react-icons/fa').then(mod => ({ default: mod.FaBolt })));
const FaBluetooth = lazy(() =>
  import('react-icons/fa').then(mod => ({ default: mod.FaBluetooth }))
);
const FaMobileAlt = lazy(() =>
  import('react-icons/fa').then(mod => ({ default: mod.FaMobileAlt }))
);

export function getKeytypeIcons(keytype, size) {
  // 图标只定义组件，不包 Suspense
  const keyIcon = <FaKey size={size || 18} />;
  const bluetoothIcon = <FaBluetooth size={size || 18} />;
  const fingerprintIcon = <IoMdFingerPrint size={size || 18} />;
  const mobilealtIcon = <FaMobileAlt size={size || 18} />;
  const signalIcon = <FaSimCard size={size || 18} />;
  const physicalIcon = <FaBolt size={size || 18} />;

  const Icons = [];
  switch (keytype) {
    // TODO: 类型后期封装为常量
    case 0: // 普通钥匙
      Icons.push(<Suspense fallback={null}>{keyIcon}</Suspense>);
      break;
    case 1: // 蓝牙钥匙
      Icons.push(<Suspense fallback={null}>{bluetoothIcon}</Suspense>);
      break;
    case 2: // 指纹钥匙
      Icons.push(<Suspense fallback={null}>{fingerprintIcon}</Suspense>);
      break;
    case 3: // 指纹蓝牙
      Icons.push(
        <Suspense fallback={null}>{fingerprintIcon}</Suspense>,
        <Suspense fallback={null}>{bluetoothIcon}</Suspense>
      );
      break;
    case 4: // 普通屏显
      Icons.push(
        <Suspense fallback={null}>{keyIcon}</Suspense>,
        <Suspense fallback={null}>{mobilealtIcon}</Suspense>
      );
      break;
    case 5: // 蓝牙屏显
      Icons.push(
        <Suspense fallback={null}>{bluetoothIcon}</Suspense>,
        <Suspense fallback={null}>{mobilealtIcon}</Suspense>
      );
      break;
    case 6: // 指纹屏显
      Icons.push(
        <Suspense fallback={null}>{fingerprintIcon}</Suspense>,
        <Suspense fallback={null}>{mobilealtIcon}</Suspense>
      );
      break;
    case 7: // 指纹蓝牙屏显
      Icons.push(
        <Suspense fallback={null}>{fingerprintIcon}</Suspense>,
        <Suspense fallback={null}>{bluetoothIcon}</Suspense>,
        <Suspense fallback={null}>{mobilealtIcon}</Suspense>
      );
      break;
    case 8: // 普通蜂窝屏显
      Icons.push(
        <Suspense fallback={null}>{signalIcon}</Suspense>,
        <Suspense fallback={null}>{mobilealtIcon}</Suspense>
      );
      break;
    case 9: // 指纹蜂窝屏显
      Icons.push(
        <Suspense fallback={null}>{fingerprintIcon}</Suspense>,
        <Suspense fallback={null}>{signalIcon}</Suspense>,
        <Suspense fallback={null}>{mobilealtIcon}</Suspense>
      );
      break;
    case 10: // 蓝牙蜂窝屏显
      Icons.push(
        <Suspense fallback={null}>{bluetoothIcon}</Suspense>,
        <Suspense fallback={null}>{signalIcon}</Suspense>,
        <Suspense fallback={null}>{mobilealtIcon}</Suspense>
      );
      break;
    case 11: // 指纹蓝牙蜂窝屏显
      Icons.push(
        <Suspense fallback={null}>{fingerprintIcon}</Suspense>,
        <Suspense fallback={null}>{bluetoothIcon}</Suspense>,
        <Suspense fallback={null}>{signalIcon}</Suspense>,
        <Suspense fallback={null}>{mobilealtIcon}</Suspense>
      );
      break;
    case 12: // 物理钥匙
      Icons.push(<Suspense fallback={null}>{physicalIcon}</Suspense>);
      break;
  }
  return Icons;
}

export function getKeytypeText(keytype) {
  const texts = [];
  // 普通钥匙
  if (keytype === 0) {
    texts.push(formatMessage('key.type.normal'));
  }
  // 指纹钥匙
  if (
    keytype === 2 ||
    keytype === 3 ||
    keytype === 6 ||
    keytype === 7 ||
    keytype === 9 ||
    keytype === 11
  ) {
    texts.push(formatMessage('key.type.fingerprint'));
  }
  // 蓝牙钥匙
  if (
    keytype === 1 ||
    keytype === 3 ||
    keytype === 5 ||
    keytype === 7 ||
    keytype === 10 ||
    keytype === 11
  ) {
    texts.push(formatMessage('key.type.ble'));
  }
  // 4g钥匙
  if (keytype === 8 || keytype === 9 || keytype === 10 || keytype === 11) {
    texts.push(formatMessage('key.type.cellular'));
  }
  // 屏显钥匙
  if (
    keytype === 4 ||
    keytype === 5 ||
    keytype === 6 ||
    keytype === 7 ||
    keytype === 8 ||
    keytype === 9 ||
    keytype === 10 ||
    keytype === 11
  ) {
    texts.push(formatMessage('key.type.screen'));
  }
  // 物理钥匙
  if (keytype === 12) {
    texts.push(formatMessage('key.type.physical'));
  }
  return texts.join('; ');
}
